import Button from '@rio-cloud/rio-uikit/Button';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface CreateNewUserStepProperties {
    onCreateUserWithEmail: () => void;
    onCreateUserWithPhone: () => void;
}

export const CreateNewUserStep = memo((props: CreateNewUserStepProperties) => {
    return (
        <div className={'padding-15'}>
            <div className={'padding-15 text-center'}>
                <div className={'text-size-18 line-height-125rel'}>
                    <FormattedMessage id={'intl-msg:user.login.method'} />
                </div>
                <div className={'text-size-12 line-height-125rel'}>
                    <FormattedMessage id={'intl-msg:user.login.selection'} />
                </div>
            </div>
            <div className={'display-flex flex-wrap justify-content-center'}>
                <Button
                    autoTrackingKey='drivers.sidebar.user-dialog.create-new-user.email'
                    bsStyle={Button.PRIMARY}
                    className='btn-action text-size-20 margin-10'
                    data-testid={'addUserByEmailBtn'}
                    onClick={props.onCreateUserWithEmail}
                >
                    <span className={'uikit-icon icon-envelope'} />
                    <FormattedMessage id={'intl-msg:email'} />
                </Button>
                <Button
                    autoTrackingKey='drivers.sidebar.user-dialog.create-new-user.phone'
                    bsStyle={Button.PRIMARY}
                    className='btn-action text-size-20 margin-10'
                    data-testid={'addUserByPhoneBtn'}
                    onClick={props.onCreateUserWithPhone}
                >
                    <span className={'uikit-icon icon-phone'} />
                    <FormattedMessage id={'intl-msg:phoneNumber'} />
                </Button>
            </div>
        </div>
    );
});

CreateNewUserStep.displayName = 'CreateNewUserStep';
